import React from "react";
import { Bar, Pie } from "react-chartjs-2";
import { Check, Clock, CornerUpRight, FileText, Gift } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import MainCardOne from "../../Dashboard/Cards/MainCardOne";
import { FirstCompBar } from "../../../../Helper/ChartDeta";

export const FirstCardComp = () => {


  const FirstCompdata = {

    labels: ['Arunachal Pradesh', 'Assam', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', "Tirupura", "West Bengal"],
    datasets: [
      {
        label: '',
        data: [10, 20, 30, 40, 50, 60, 70, 80],
        fill: true,
        backgroundColor: [
          "#8A2387",
          "#E94057",
          "#44A08D",
          "#F27121",
          "#8A2387",
          "#E94057",
          "#44A08D",
          "#F27121",

        ],

      },
    ],
  };


  return (
    <div>


      {/* <div className="row  mr-1 mr-lg-0 ">
          <MainCardOne
            img="./static/assets/img/dashboard/surveyor.png"
            title="Total Area planted (Ha) "
            count="346"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            cardBodyBg="card-body Card-1 p-4 "
            background="#1b306661"
            duration="Since Last Year"
            button="onClick={() => handleChange()}"
          // navigateTo="/Branch-Enquiry-received"
          />
          <MainCardOne
            // icon={<Check />}
            img="./static/assets/img/dashboard/beneficiary.png"
            title="Total Beneficiaries Surveyed (No’s) "
            count="346"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            background="#ff6500b8"
            cardBodyBg="card-body Card-2"
            duration="Since Last Year"
          // navigateTo="/Branch-Enquiry-Approved"
          />
          <MainCardOne
            // icon={<Clock />}
            img="./static/assets/img/dashboard/Plantations.png"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            title="Total Area Monitored (Ha) "
            count="346"
            cardBodyBg="card-body Card-3"
            background="#1b306661"
            duration="Since Last Year"
          // navigateTo="/Branch-Enquiry-pending"
          />

        </div> */}
      <h5 className="fw-bold py-1 pt-2">Dashboard</h5>
      <div className="row shadow2 my-2 mt-3  p-3" style={{ background: '#FAFCFE', borderRadius: '6px' }}>
        {/* <h5 className="fw-bold py-1 pt-2">Dashboard</h5> */}
        <div className="col-12   border rounded mx-auto shadow2">
          <div className="row" style={{ backgroundColor: '#e9ecef', border: '1px solid #b9b9b936' }}>

            <div className="col-12 col-lg-4 border_right mt-1">
              <div class="row  ">
                <div class="col-4 d-flex align-items-center justify-content-center" >
                  <img src="./static/assets/img/dashboard/Area.png" alt="" style={{ width: "60%" }} />
                </div>
                <div class="col-8 px-3 pt-3 ps-4 ">
                  <h6 className="fw-bold">Total Area planted <br /> (Ha)</h6>
                  <h3 className="fw-bold" style={{ color: '#EF4069' }}>1000</h3>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-4 border_right mt-1">
              <div class="row  ">
                <div class="col-4 d-flex align-items-center justify-content-center" >
                  <img src="./static/assets/img/dashboard/survey.png" alt="" style={{ width: "60%" }} />
                </div>
                <div class="col-8 px-3 pt-3 ps-4 ">
                  <h6 className="fw-bold">Total Beneficiaries Surveyed (No’s) </h6>
                  <h3 className="fw-bold" style={{ color: '#EF4069' }}>1000</h3>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-4  mt-1">
              <div class="row  ">
                <div class="col-4 d-flex align-items-center justify-content-center" >
                  <img src="./static/assets/img/dashboard/Monitored .png" alt="" style={{ width: "60%" }} />
                </div>
                <div class="col-8 px-3 pt-3 ps-4 ">
                  <h6 className="fw-bold">Total Area Monitored (Ha) </h6>
                  <h3 className="fw-bold" style={{ color: '#EF4069' }}>1000</h3>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div className="row">
          <div className="col-12 col-lg-11 py-3 ">
            <Bar
              options={FirstCompBar}
              data={FirstCompdata}
              height={'80px'}
            />
          </div>
          <div className="col-12 col-lg-1 py-5 text-center">
            <a href=""><span className="reports">  Reports</span></a>
          </div>
        </div>

      </div>
    </div>
  );
};
